import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Phone, Mail, MapPin } from 'lucide-react';
export const ContactSection = () => {
  const handlePhoneCall = () => {
    window.location.href = 'tel:+33608248529';
  };
  const handleEmail = () => {
    window.location.href = 'mailto:trucks.52@orange.fr';
  };
  const handleDirections = () => {
    window.open('https://maps.google.com/?q=2+PLACE+DE+L\'EGLISE+RECOURT+52140+VAL-DE-MEUSE', '_blank');
  };
  return <section className="bg-gray-900 text-white py-[10px]" id="contact">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Contactez-nous
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Notre équipe est à votre disposition pour répondre à toutes vos questions 
            et vous accompagner dans votre projet
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Contact Cards */}
          <div className="grid md:grid-cols-3 gap-6">
            <Card className="bg-gray-800 border-gray-700 hover:bg-gray-750 transition-colors py-[5px]">
              <CardContent className="p-6 py-0 px-[5px]">
                <div className="text-center">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Phone className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Téléphone</h3>
                  <p className="text-gray-300 mb-4">Appelez-nous directement</p>
                  <Button onClick={handlePhoneCall} className="bg-blue-600 hover:bg-blue-700 text-white">
                    <Phone className="h-4 w-4 mr-2" />
                    06 08 24 85 29
                  </Button>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gray-800 border-gray-700 hover:bg-gray-750 transition-colors">
              <CardContent className="p-6 py-[5px] px-[5px]">
                <div className="text-center">
                  <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Mail className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Email</h3>
                  <p className="text-gray-300 mb-4">Envoyez-nous un message</p>
                  <Button onClick={handleEmail} className="bg-blue-600 hover:bg-blue-700 text-white border-blue-600">
                    <Mail className="h-4 w-4 mr-2" />
                    Nous contacter
                  </Button>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gray-800 border-gray-700 hover:bg-gray-750 transition-colors">
              <CardContent className="p-6 py-[5px] px-[5px]">
                <div className="text-center">
                  <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <MapPin className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Localisation</h3>
                  <p className="text-gray-300 mb-4">Venez nous voir,
sur rendez-vous</p>
                  <Button onClick={handleDirections} className="bg-blue-600 hover:bg-blue-700 text-white border-blue-600">
                    <MapPin className="h-4 w-4 mr-2" />
                    Voir sur la carte
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Informations légales */}
          <div className="text-center mt-12 pt-8 border-t border-gray-700">
            <p className="text-gray-400 text-sm">Trucks 52 SARL - SIRET: 508 009 495 00013</p>
            <p className="text-gray-500 text-xs mt-2">2 Place de l'Église, Recourt - 52140 Val-de-Meuse</p>
          </div>
        </div>
      </div>
    </section>;
};